import { ColumnDef, createColumnHelper } from '@tanstack/react-table'

import { OrdersCardsDataTypes } from 'types/orders-details-westfieldcons'

export const useTablesOrdersCards = ({
  dataTable,
}: {
  dataTable: OrdersCardsDataTypes[]
}) => {
  const columnHelper = createColumnHelper<OrdersCardsDataTypes>()
  const columns = [
    columnHelper.accessor('orderId', {
      header: () => 'Order #',
      cell: (info) => {
        const traderId = info.getValue()

        return (
          <p className="flex flex-col">
            <span>{traderId}</span>
          </p>
        )
      },
    }),
    columnHelper.accessor('orderDate', {
      header: () => 'Order Date',
      cell: (info) => {
        const dateString = info.getValue()
        if (!dateString) return '-'

        const [datePart, timePart] = dateString.split(' ')
        const [year, month, day] = datePart.split('-')

        return `${day}/${month}/${year} ${timePart}`
      },
    }),
    columnHelper.accessor('cardNumber', {
      header: () => 'Card #',
      cell: (info) => {
        const card = info.getValue()

        return (
          <p className="flex flex-col">
            <span>{card}</span>
          </p>
        )
      },
    }),
    columnHelper.accessor('sentTo', {
      header: () => 'From/To',
      cell: ({ row }) => {
        const { original } = row
        const { sentFrom, sentTo } = original

        return (
          <p className="flex flex-col">
            <span>From: {sentFrom}</span>
            <span>To: {sentTo}</span>
          </p>
        )
      },
    }),
    columnHelper.accessor('message', {
      header: () => 'Message',
      cell: ({ row }) => {
        const { original } = row
        const { message } = original

        return (
          <p className="flex flex-col">
            <span>{message}</span>
          </p>
        )
      },
    }),
    columnHelper.accessor('address1', {
      header: () => 'Delivery Address',
      cell: ({ row }) => {
        const { original } = row
        const { address1, address2, suburb, city, state, postCode } = original

        return (
          <p className="flex flex-col">
            <span>{address1}</span>
            <span>{address2}</span>
            <span>{suburb}</span>
            <span>{city}</span>
            <span>{state}</span>
            <span>{postCode}</span>
          </p>
        )
      },
    }),
  ] as ColumnDef<OrdersCardsDataTypes>[]

  return {
    dataTable,
    columns,
  }
}
